/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IssueAction
 */
export interface IssueAction {
    /**
     * 
     * @type {string}
     * @memberof IssueAction
     */
    readonly key: string;
    /**
     * 
     * @type {string}
     * @memberof IssueAction
     */
    readonly name: string;
}

/**
 * Check if a given object implements the IssueAction interface.
 */
export function instanceOfIssueAction(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "key" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function IssueActionFromJSON(json: any): IssueAction {
    return IssueActionFromJSONTyped(json, false);
}

export function IssueActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): IssueAction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key': json['key'],
        'name': json['name'],
    };
}

export function IssueActionToJSON(value?: IssueAction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}

